import { type SVGProps } from "react";

interface IProps extends SVGProps<SVGSVGElement> {}

export const Instagram = (props: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 40 40"
      {...props}
    >
      <g fill="inherit">
        <path d="M25.887 8.523H13.929a6 6 0 0 0-5.991 5.992v10.94a6 6 0 0 0 5.99 5.991h11.959a6 6 0 0 0 5.991-5.991v-10.94a6 6 0 0 0-5.991-5.992M10.05 14.515a3.883 3.883 0 0 1 3.878-3.878h11.958a3.883 3.883 0 0 1 3.878 3.878v10.94a3.883 3.883 0 0 1-3.878 3.877H13.929a3.883 3.883 0 0 1-3.878-3.877z" />
        <path d="M19.909 25.556a5.58 5.58 0 0 0 5.573-5.573 5.58 5.58 0 0 0-5.573-5.573 5.58 5.58 0 0 0-5.573 5.573 5.58 5.58 0 0 0 5.573 5.573m0-9.031a3.463 3.463 0 0 1 3.46 3.46 3.463 3.463 0 0 1-3.46 3.459 3.463 3.463 0 0 1-3.46-3.46 3.463 3.463 0 0 1 3.46-3.459m6.089-1.213a1.502 1.502 0 1 0-.002-3.001 1.502 1.502 0 0 0 .002 3" />
      </g>
    </svg>
  );
};
